import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, MessageSquare } from 'lucide-react';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.pexels.com/photos/32399141/pexels-photo-32399141.jpeg" 
          alt="Industrial Manufacturing"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-bharat-blue/95 via-bharat-blue/85 to-bharat-blue/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8 animate-fade-in">
            <span className="text-white text-sm font-medium">Trusted B2B Distributor | Serving North India</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-slide-up">
            India's Trusted
            <span className="block text-manufacturing-orange">Titanium Dioxide</span>
            Distribution Partner
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-white/90 mb-4 font-semibold animate-slide-up animation-delay-200">
            Reliable supply. Competitive pricing. Industrial-scale execution across North India.
          </p>

          {/* Description */}
          <p className="text-lg text-white/80 mb-10 leading-relaxed animate-slide-up animation-delay-300">
            Bharat Enterprises is a leading B2B distributor of Titanium Dioxide (TiO₂), 
            serving SME and MSME manufacturers across paints, plastics, PVC, footwear, cosmetics, and industrial sectors.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-slide-up animation-delay-400">
            <Button 
              size="lg"
              onClick={() => scrollToSection('contact')}
              className="bg-manufacturing-orange hover:bg-manufacturing-orange/90 text-white text-lg px-8 py-6 group"
            >
              Request a Quote
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('contact')}
              className="border-2 border-white text-white hover:bg-white hover:text-bharat-blue text-lg px-8 py-6"
            >
              <MessageSquare className="mr-2" />
              Contact Sales
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 mt-16 animate-slide-up animation-delay-500">
            <div className="border-l-4 border-manufacturing-orange pl-4">
              <div className="text-3xl font-bold text-white">40+</div>
              <div className="text-white/70 text-sm">Years Experience</div>
            </div>
            <div className="border-l-4 border-manufacturing-orange pl-4">
              <div className="text-3xl font-bold text-white">1000+</div>
              <div className="text-white/70 text-sm">Customers</div>
            </div>
            <div className="border-l-4 border-manufacturing-orange pl-4">
              <div className="text-3xl font-bold text-white">20+</div>
              <div className="text-white/70 text-sm">Industries Served</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/50 rounded-full animate-scroll"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
